angular.module('property-deal')
    .controller('PropertyDealLivingAreaFinalController', function ($http, $scope, $rootScope, $uibModalInstance, data, PropertyDeal) {
        this.livingAreaConfirmationRequiredThreshold = 2.0

        this.$onInit = () => {
            this.form = data
        }
        this.recalculate = () => {
            this.form.confirmation = null
            this.form.diffPercent = this.form.livingAreaFinal == null ? 0 : Math.abs(this.form.livingAreaFinal - this.form.livingArea) / this.form.livingArea * 100
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.save = () => {
            return PropertyDeal.livingAreaFinalUpdate(this.form).$promise.then(result => {
                $rootScope.$broadcast('property-deal.updated', result)
                $uibModalInstance.close(this.form)
            })
        };
    })
